import { footerColumns, navLinks, siteBrand } from "@/mocks/home";

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-100">
      <div className="mx-auto max-w-shell px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <a href="#top" className="flex items-center gap-3 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50 dark:text-foreground-950">
                31
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">{siteBrand}</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              聚合<span className="text-foreground-800">31黑料网黑料专题</span>、
              <span className="text-foreground-800">黑料专区</span>、
              <span className="text-foreground-800">黑料频道</span>与
              <span className="text-foreground-800">黑料导航</span>，
              一站直达最新爆料内容，持续更新不迷路。
            </p>

            <div className="mt-6 flex flex-wrap gap-2">
              {navLinks.map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  className="whitespace-nowrap rounded-full border border-secondary-200 bg-secondary-50 px-3.5 py-1.5 text-xs font-label text-secondary-900 transition-colors duration-300 hover:border-primary-300 hover:text-primary-700 cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3 lg:col-span-7">
            {footerColumns.map((column) => (
              <div key={column.title}>
                <h3 className="font-heading text-sm font-bold tracking-wide text-foreground-950">
                  {column.title}
                </h3>
                <ul className="mt-4 flex flex-col gap-3">
                  {column.links.map((link) => (
                    <li key={link}>
                      <a
                        href="#nav"
                        className="text-sm text-foreground-600 transition-colors duration-300 hover:text-primary-700 cursor-pointer"
                      >
                        {link}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs font-label text-foreground-500">
            © 2026 {siteBrand} · 黑料专题聚合页 · 本站内容仅为信息整理展示
          </p>
          <div className="flex flex-wrap items-center gap-5">
            <a
              href="#nav"
              className="text-xs font-label text-foreground-500 transition-colors duration-300 hover:text-primary-700 cursor-pointer"
            >
              免责声明
            </a>
            <a
              href="#nav"
              className="text-xs font-label text-foreground-500 transition-colors duration-300 hover:text-primary-700 cursor-pointer"
            >
              内容申诉
            </a>
            <a
              href="#top"
              className="inline-flex items-center gap-1.5 whitespace-nowrap text-xs font-label text-foreground-500 transition-colors duration-300 hover:text-primary-700 cursor-pointer"
            >
              回到顶部
              <i className="ri-arrow-up-line text-sm" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}